<template>

    <v-list-item>
        <div>
            <span>{{ dataInvite.email | truncate(30) }}</span><br>
            <span class="small">{{ dataInvite.role.name }}</span>
        </div>
        <div class="grid">
            <span>Invited<br><span class="small">{{ dataInvite.invited_at | date }}</span></span>
            <span>Expires<br><span class="small" :class="{ 'text-danger': isExpired }">{{ dataInvite.expired_at | date }}</span></span>
            <div class="d-flex align-items-center justify-content-end">
                <v-button-toolbar>
                    <v-button class="float-right" size="sm" btn-style="secondary" :loading="loading" @click.native="resendMemberInvite">Resend</v-button>
                    <v-button class="float-right" size="sm" btn-style="danger" @click.native="$emit('delete', invite)">Delete</v-button>
                </v-button-toolbar>
            </div>
        </div>
    </v-list-item>

</template>

<script>

import moment from 'moment';
import MemberInviteApi from '@api/MemberInviteApi';

export default {

    props: {
        invite: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            dataInvite: this.invite,
            loading: false,
        }
    },

    computed: {

        isExpired() {
            return moment.unix(this.invite.expired_at).isBefore();
        },

    },

    methods: {

        resendMemberInvite() {
            this.loading = true;
            MemberInviteApi.resendMemberInvite(this.invite.id)
                .then((response) => {
                    this.loading = false;
                    this.dataInvite = response.data.data;
                }, () => {
                    this.loading = false;
                });
        },

    },

}

</script>
